import React from 'react'
import styled from 'styled-components'
import { HtmlContent } from '@mediahuis/chameleon-react'
import { getBrand } from '../../../core/pure/Env'

type MoreInfoTextProps = {
  html: string
}

export const MoreInfoText: React.FC<MoreInfoTextProps> = ({ html }) => {
  if (getBrand() === 'dl') return null
  return (
    <HtmlContent>
      <ContentInfo>
        <div dangerouslySetInnerHTML={{ __html: html }}></div>
      </ContentInfo>
    </HtmlContent>
  )
}

const ContentInfo = styled.div`
  p,
  a {
    color: black;
    font-size: 14px !important;
  }
`
